import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService, UserService} from "../services";
import { Subject } from 'rxjs';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';


import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {ReservationData} from "../models/reservationData";
import {ActivatedRoute} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {AddParticipantDialogComponent} from "./dialog/addParticipantDialog.component";
import {FormGroup} from "@angular/forms";
import {GroupActivityService} from "./service/groupActivity.service";
import {first} from "rxjs/operators";
import {GroupActivity} from "../models/groupActivity";
import {MatSnackBar} from "@angular/material/snack-bar";
import {GroupActivityCustomer} from "../models/GroupActivityCustomer";
import {DeleteParticipantDialogComponent} from "./dialog/deleteParticipantDialog.component";

@Component({
    templateUrl: './groupActivity.component.html',
    styleUrls: ['./groupActivity.component.scss']
})
export class GroupActivityComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    reservation: ReservationData;
    locale: 'pl';
    addParticipantDialogRef: any;
    deleteParticipantDialogRef: any;
    loading: boolean = false;
    confirmedQuantity: number = 0;
    trainedQuantity: number = 0;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private _fuseSidebarService: FuseSidebarService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private route: ActivatedRoute,
        private groupActivityService: GroupActivityService,
        private _matSnackBar: MatSnackBar,
        public _matDialog: MatDialog,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Group activity');

        this.reservation = this.route.snapshot.data.reservation;

        for (let i = 0; i < this.reservation.groupActivity.participants.length; i++) {
            if (this.reservation.groupActivity.participants[i].confirmed) {
                this.confirmedQuantity++;
            }

            if (this.reservation.groupActivity.participants[i].tookPartIn) {
                this.trainedQuantity++;
            }
        }
    }

    ngOnInit() {

    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

    markAsConfirmed(customer: GroupActivityCustomer)
    {
        this.groupActivityService.markAsConfirmed(customer).pipe(first())
            .subscribe(res => {
                this._matSnackBar.open('Participant has been marked as confirmed', 'OK', {
                    verticalPosition: 'top',
                    duration: 5000,
                    panelClass: ['snackbar-success']
                });

                window.location.reload();
            }, err => {

            });
    }

    markAsTookPartIn(customer: GroupActivityCustomer)
    {
        this.groupActivityService.markAsTookPartIn(customer).pipe(first())
            .subscribe(res => {
                this._matSnackBar.open('Participant has been marked as took part in', 'OK', {
                    verticalPosition: 'top',
                    duration: 5000,
                    panelClass: ['snackbar-success']
                });

                window.location.reload();
            }, err => {

            });
    }

    openDeleteParticipantDialog(groupActivity: GroupActivity, participant: GroupActivityCustomer)
    {
        this.deleteParticipantDialogRef = this._matDialog.open(DeleteParticipantDialogComponent, {
            panelClass: 'delete-participant-dialog',
            data      : {
                action : 'show',
            },
            width: '550px',
        });

        this.deleteParticipantDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.groupActivityService.deleteParticipant(participant.id, groupActivity.id).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteParticipantDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    openAddParticipantDialog(reservation: ReservationData)
    {
        this.addParticipantDialogRef = this._matDialog.open(AddParticipantDialogComponent, {
            panelClass: 'add-participant-dialog',
            data      : {
                action : 'show',
                reservation: reservation,
            },
            width: '550px',
        });

        this.addParticipantDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.groupActivityService.addParticipant(reservation, response.getRawValue().customer).pipe(first())
                    .subscribe((res: GroupActivity) => {
                        this.loading = false;
                        this._matSnackBar.open('Participant has been added', 'OK', {
                            verticalPosition: 'top',
                            duration: 5000,
                            panelClass: ['snackbar-success']
                        });
                        this.reservation.groupActivity = res;
                    }, err => {
                        this.loading = false;
                        this._matSnackBar.open('Error - ' + err, 'OK', {
                            verticalPosition: 'top',
                            duration: 5000,
                            panelClass: ['snackbar-error']
                        });
                    });
            });
    }
}
